const LOCAL = "local";
const DEVELOPMENT = "development";
const TESTING = "testing";
const SANDBOX = "sandbox";
const PRODUCTION = "production";

export { LOCAL, DEVELOPMENT, TESTING, SANDBOX, PRODUCTION };
